/*******************************************************************************************************************
 *                                     FarrisPrimengTreeTableBindingDirectiveæä»¤è¯´æ                               *
 * *****************************************************************************************************************
 *
 * 1. ä¾èµprimengçæ¬: primeng:^9.0.0,primeicons:^4.0.0
 *
 * 2. ç±äºå¯ç¼è¾æ è¡¨æ æ³è§¦åç¼è¾ååæ ¼çå³é­äºä»¶onEditCompleteï¼å æ­¤å¯¹priemengçnode_modules\primeng\fesm5\primeng-treetable.jsèæ¬ä½åºä¿®æ¹ï¼
 *    æºç ä¿®æ¹å¦ä¸ï¼+è¡¨ç¤ºæ°å¢å çèæ¬è¯­å¥:
 *
 *  TreeTable.prototype.updateEditingCell = function (cell, data, field) { //+ åæ°å¢å dataåfield
 *      this.editingCell = cell;
 *      this.editingCellData = data; //+
 *      this.editingCellField = field; //+
 *      this.bindDocumentEditListener();
 *  };
 *
 *  TreeTable.prototype.bindDocumentEditListener = function () {
 *       var _this = this;
 *       if (!this.documentEditListener) {
 *           this.documentEditListener = function (event) {
 *               if (_this.editingCell && !_this.editingCellClick && _this.isEditingCellValid()) {
 *                   domhandler_1.DomHandler.removeClass(_this.editingCell, 'ui-editing-cell');
 *                   _this.editingCell = null;
 *                   _this.onEditComplete.emit({ field: _this.editingCellField, data: _this.editingCellData });//+
 *                   _this.unbindDocumentEditListener();
 *               }
 *               _this.editingCellClick = false;
 *           };
 *           document.addEventListener('click', this.documentEditListener);
 *       }
 *   };
 *
 *  TreeTable.prototype.bindDocumentEditListener = function () {
 *       var _this = this;
 *       if (!this.documentEditListener) {
 *           this.documentEditListener = function (event) {
 *               if (_this.editingCell && !_this.editingCellClick && _this.isEditingCellValid()) {
 *                   domhandler_1.DomHandler.removeClass(_this.editingCell, 'ui-editing-cell');
 *                   _this.editingCell = null;
 *                   _this.onEditComplete.emit({ field: _this.editingCellField, data: _this.editingCellData });//+
 *                   _this.unbindDocumentEditListener();
 *               }
 *               _this.editingCellClick = false;
 *           };
 *           document.addEventListener('click', this.documentEditListener);
 *       }
 *   };
 *
 *  TTEditableColumn.prototype.openCell = function () {
 *       var _this = this;
 *        this.tt.updateEditingCell(this.el.nativeElement,this.data, this.field);//+
 *        domhandler_1.DomHandler.addClass(this.el.nativeElement, 'ui-editing-cell');
 *        this.tt.onEditInit.emit({ field: this.field, data: this.data });
 *        this.zone.runOutsideAngular(function () {
 *            setTimeout(function () {
 *                var focusable = domhandler_1.DomHandler.findSingle(_this.el.nativeElement, 'input, textarea');
 *                if (focusable) {
 *                     focusable.focus();
 *                 }
 *             }, 50);
 *        });
 *   };
 *
 *  TTEditableColumn.prototype.onClick = function (event) {
 *        if (this.isEnabled()) {
 *            this.tt.editingCellClick = true;
 *            if (this.tt.editingCell) {
 *                if (this.tt.editingCell !== this.el.nativeElement) {
 *                    if (!this.tt.isEditingCellValid()) {
 *                        return;
 *                    }
 *                    this.tt.onEditComplete.emit({ field: this.tt.oldField, data: this.tt.oldDdata });//+
 *                    DomHandler.removeClass(this.tt.editingCell, 'ui-editing-cell');
 *                    this.openCell();
 *                }
 *            }
 *            else {
 *                this.openCell();
 *            }
 *        }
 *  };
 *
 *  TTEditableColumn.prototype.openCell = function () {
 *         var _this = this;
 *         this.tt.updateEditingCell(this.el.nativeElement,this.data, this.field);
 *         DomHandler.addClass(this.el.nativeElement, 'ui-editing-cell');
 *         this.tt.onEditInit.emit({ field: this.field, data: this.data });
 *         this.tt.oldField= this.field; //+
 *         this.tt.oldDdata=this.data;  //+
 *         this.zone.runOutsideAngular(function () {
 *             setTimeout(function () {
 *                 var focusable = DomHandler.findSingle(_this.el.nativeElement, 'input, textarea');
 *                if (focusable) {
 *                     focusable.focus();
 *                 }
 *           }, 50);
 *       });
 *   };
 *
 * 3. HTMLæ¨¡æ¿
 * (1) ä¸å¯ç¨å¤è¡¨å¤´
 *      <p-treeTable [columns]="treeGridColumns" farrisPrimengTreeTableBinding farrisHierarchyInfoKey="layerField" [resizableColumns]="true" farrisPrimengTreeTableIdField="id">
 *             <ng-template pTemplate="header" let-columns>
 *                 <tr>
 *                     <th *ngFor="let col of columns" ttResizableColumn>
 *                         {{col.header}}
 *                     </th>
 *                 </tr>
 *             </ng-template>
 *             <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
 *                 <tr>
 *                     <td *ngFor="let col of columns; let i = index" ttEditableColumn [ttEditableColumn]="rowData"
 *                         [ttEditableColumnField]="col.field">
 *                         <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
 *                         <p-treeTableCellEditor>
 *                             <ng-template pTemplate="input">
 *                                  <!-- æ§ä»¶å¨æçæåºåï¼æ­¤å¤å¯æ¾ç½®æ§ä»¶å¨æçæç»ä»¶ï¼çæè§åå¦ä¸ï¼
 *                                            1. å­ç¬¦ä¸²ç±»åï¼ææ¬æ§ä»¶
 *                                            2. æ°å­ç±»åï¼æ°å­æ§ä»¶
 *                                            3. å¸å°ç±»åï¼å¤éæ¡æ§ä»¶
 *                                            4. æ¥ææ¶é´ç±»åï¼æ¥ææ¶é´æ§ä»¶
 *                                            5. æä¸¾ç±»åï¼ä¸ææ¡æ§ä»¶
 *                                            6. å¸®å©ç±»åï¼å¸®å©æ§ä»¶-->
 *                             </ng-template>
 *                             <ng-template pTemplate="output">{{ col | formatCellData : rowData }}</ng-template>
 *                         </p-treeTableCellEditor>
 *                     </td>
 *                 </tr>
 *             </ng-template>
 *     </p-treeTable>
 *
 * (2) å¯ç¨å¤è¡¨å¤´
 *
 *  <p-treeTable [columns]="treeGridColumns" farrisPrimengTreeTableBinding farrisHierarchyInfoKey="layerField" [resizableColumns]="true" farrisPrimengTreeTableIdField="id">
 *             <ng-template pTemplate="header" let-columns>
 *                  <tr *ngFor="let columnHeader of treeGridColumnHeaders">
 *                      <th *ngFor="let col of columnHeader" ttResizableColumn [attr.rowspan]="col.rowspan" [attr.colspan]="col.colspan">
 *                          {{col.header}}
 *                      </th>
 *                  </tr>
 *             </ng-template>
 *             <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
 *                 <tr>
 *                     <td *ngFor="let col of columns; let i = index" ttEditableColumn [ttEditableColumn]="rowData"
 *                         [ttEditableColumnField]="col.field">
 *                         <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
 *                         <p-treeTableCellEditor>
 *                             <ng-template pTemplate="input">
 *                                  <!-- æ§ä»¶å¨æçæåºåï¼æ­¤å¤å¯æ¾ç½®æ§ä»¶å¨æçæç»ä»¶ï¼çæè§åå¦ä¸ï¼
 *                                            1. å­ç¬¦ä¸²ç±»åï¼ææ¬æ§ä»¶
 *                                            2. æ°å­ç±»åï¼æ°å­æ§ä»¶
 *                                            3. å¸å°ç±»åï¼å¤éæ¡æ§ä»¶
 *                                            4. æ¥ææ¶é´ç±»åï¼æ¥ææ¶é´æ§ä»¶
 *                                            5. æä¸¾ç±»åï¼ä¸ææ¡æ§ä»¶
 *                                            6. å¸®å©ç±»åï¼å¸®å©æ§ä»¶-->
 *                             </ng-template>
 *                             <ng-template pTemplate="output">{{ col | formatCellData : rowData }}</ng-template>
 *                         </p-treeTableCellEditor>
 *                     </td>
 *                 </tr>
 *             </ng-template>
 *  </p-treeTable>
 *
 * å¤è¡¨å¤´æ°æ®æ ¼å¼ï¼
 *  this.treeGridColumnHeaders=[
 *     [{ header: 'Brand',rowspan:3, colspan:1},{ header: 'Sale Rate',rowspan:1, colspan:4}],
 *     [{ header: 'Sales',rowspan:1, colspan:2},{ header: 'Profits',rowspan:1, colspan:2}],
 *     [{ header: 'Last Year',rowspan:1, colspan:1},{ header: 'This Year',rowspan:1, colspan:1},{ header: 'Last Year',rowspan:1, colspan:1},{ header: 'This Year',rowspan:1, colspan:1}],
 *  ]

 **********************************************************************************************************************/

import { Directive, OnInit, OnChanges, SimpleChanges, Input, HostListener, Output, EventEmitter, Type } from '@angular/core';
import { BindingData, BindingList, FrameContext, Change, ChangeType, EntityCollection, EntityList, Entity, ComponentType } from '@farris/devkit';
import { TreeTable } from 'primeng/treetable';
import { TreeNode } from 'primeng/api';
import { TreeNodeBuilderFactory } from '../tree_table_node_builder/tree_node_builder_factory';
import { DateTimeHelperService } from '@farris/ui-common/date';
const PARENT_ELEMENT: string = "parentElement";
const PATH: string = "path";
const IS_DETAIL: string = 'isDetail';

export interface FarrisPrimengTreeNode extends TreeNode {
  id?: string;
}

@Directive({
  selector: '[farrisPrimengTreeTableBinding]'
})
export class FarrisPrimengTreeTableBindingDirective implements OnInit, OnChanges {
  private selectedRowId = null;
  private treeTableSelectedEvent = null;
  /**
   * åçº§ç ä¿¡æ¯å­æ®µï¼å±æ§å¯è½æä¸¤ç§æ ¼å¼çå¼ï¼åçº§ç å­æ®µï¼ä¸»è¡¨ï¼æä»è¡¨åç«¯codes/åçº§ç å­æ®µï¼å­è¡¨ï¼
   */
  @Input('farrisHierarchyInfoKey')
  public hierarchyInfoKey: string;
  @Input('columns')
  public columns: any;
  /**
   * åç ï¼æ°æ®çå¯ä¸æ è¯
   */
  @Input('farrisPrimengTreeTableIdField')
  public idField: string;

  /**
   * èç¹éæ©åæ´äºä»¶
   */
  @Output() nodeSelectChange: EventEmitter<any> = new EventEmitter<any>();

  private oldTreeNodeMap: { [key: string]: FarrisPrimengTreeNode } = {};


  /**
   * åçº§ç çå­æ®µç¼å·ï¼ä»hierarchyInfoKeyå±æ§ä¸­è§£æè·å
   */
  private hierarchyInfoField: string;

  /**
   * ç»å®æ°æ®
   */
  private get bindingData(): BindingData {
    return this.frameContext.bindingData;
  }

  /**
   * ç»å®æ°æ®åè¡¨
   */
  private get bindingList(): BindingList {
    return this.bindingData.getList();
  }

  private getHierarchyInfoField(): string {
    const infos = this.hierarchyInfoKey.split('/');
    return infos[infos.length - 1];
  }

  constructor(
    private treeTable: TreeTable,
    private frameContext: FrameContext,
    private dateService: DateTimeHelperService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    // è§£æè·ååçº§ç å­æ®µç¼å·
    this.hierarchyInfoField = this.getHierarchyInfoField();
    // å°åçº§ç ä¿¡æ¯ä¿å­å°root-component
    const virtualRootFrameContext = this.frameContext.getVirtualRootFrameContext();
    virtualRootFrameContext.setParam('hierarchyInfoKey', this.hierarchyInfoKey.split('/').filter(p=>p).join('/'));
    this.bindingData.changes.subscribe((change: Change) => {
      this.bindData(change);
      this.updateSelectedRow(change);
    });
    this.frameContext.viewModel.uiState.setPropertyValue('ids', []);
    if (this.frameContext && this.frameContext.frameComponent) {
      this.frameContext.frameComponent.componentType = ComponentType.primengTreeComponent;
    }
  }

  /**
   * è·åæ åè¡¨ç»å®æ°æ®å¯¹åºçå®ä½æ°ç»
   * @returns å®ä½æ°ç»
   */
  private getEntityArr(): Entity[] {
    const entityCollection = this.frameContext.repository.entityCollection;
    const bindingPath: string = this.frameContext.bindingData.bindingPath;
    if (!bindingPath || bindingPath === '/') {
      return entityCollection.toArray();
    }
    let bindingList: BindingList = this.frameContext.bindingData.list;
    let bindingPathArr: string[] = bindingPath.split('/').filter(str => str);
    let pathArray = [];
    bindingPathArr.forEach((path: string) => {
      pathArray.push(`${bindingList.primaryKey}:${bindingList.currentId}`);
      pathArray.push(path);
      bindingList = bindingList.currentItem[path];
    });
    return (entityCollection.getEntitiesByPath(pathArray) as EntityList<any>).toArray();
  }
  /**
   * å°çå®é¡ºåºæ è®°å°å¯¹åºçå®ä½ä¸
   * @param entityArr å®ä½æ°ç»
   * @param treeNodes æ èç¹
   */
  private setActualIndex(entityArr: Entity[], treeNodes: TreeNode[]) {
    if (entityArr.length < 1)
      return;
    // åå§ååºå·å¨å¹¶ä¾æ¬¡éåæ¯ä¸æ£µæ 
    let counter = { index: 0 };
    const primaryKey: string = entityArr[0].primaryKey;
    treeNodes.forEach((rootNode) => {
      this.traverseTree(rootNode, counter, entityArr, primaryKey);
    });
  }
  /**
   * ååºéå½éåæ èç¹å¹¶å¨å¯¹åºå®ä½ä¸æ è®°åºå·
   * @param treeNode æ èç¹
   * @param counter åºå·å¨
   * @param entityArr å®ä½æ°ç»
   * @description
   * å¨è¿è¡åç«¯æ ¡éªæ¶ï¼æç§Entityå¨æ°ç»ä¸­çä¸æ çæï¼éè¯¯æç¤ºçï¼è¡å·çæ¹å¼ä¸éç¨äºæ åè¡¨ï¼
   * å ä¸ºæ åè¡¨å¯ä»¥å¨å·²ç»æ·»å çèç¹ä¸å å¥å­èç¹ï¼èEntityæ»æ¯å¨æåè¿½å æ°å¯¹è±¡ï¼å¯¼è´äºèçé¡ºåºä¸ä¸å®ç¸åï¼
   * æä»¥å¨ç»å®æ°æ®çæ¶åå°æ èç¹å¨åè¡¨ä¸­ççå®é¡ºåºéè¿ä¸ä¸ªéå çå±æ§ï¼__ACTUAL_INDEX__ï¼èµç»Entityç¤ºä¾ï¼
   * å½Entityè°ç¨validateæ¹æ³æ¶ï¼æ£æ¥æ¯å¦å­å¨è¯¥å±æ§ï¼å¦æå­å¨ååºç¨è¯¥å±æ§çå¼ä½ä¸ºè¡å·ã
   */
  private traverseTree(treeNode: TreeNode, counter: { index: number }, entityArr: Entity[], primaryKey: string) {
    const INDEX_LABEL = "__ACTUAL_INDEX__";
    // å¤çå½åèç¹
    const entity = entityArr.find(e => e[primaryKey] === treeNode.data[primaryKey]);
    if (entity) {
      Object.defineProperty(entity, INDEX_LABEL, {
        value: counter.index
      });
      counter.index++;
    }
    // éå½éååæ¯
    treeNode.children.forEach((rootNode) => {
      this.traverseTree(rootNode, counter, entityArr, primaryKey);
    });
  }

  /**
   * å¤çæ°æ®åæ´
   * @param change åæ´
   * @returns æ¯å¦è·³è¿ç»å®æ°æ®çæ´ä½å·æ°
   * @description
   * ç®çæ¯å°½éå°çéæ°æé æ´ä¸ªæ åè¡¨ï¼æ¯å¦å¨åçå¼ååäºä»¶æ¶å°½éåªæ´æ¹ååçå¼å°±ç»æï¼
   * å¦æä»»ä½ååé½éæ°æé æ ï¼ä¼å¯¼è´Tabé®åæ¢åè½é¾ä»¥å®ç°ç­é®é¢ã
   */
  private handleChange(change?: Change): boolean {
    // æ²¡æåæ´æ¶ï¼ç»§ç»­ç»å®æ°æ®å·æ°
    if (!change)
      return false;
    // åç±»å¤çå·ä½çåæ´
    switch (change.type) {
      case ChangeType.SelectionChanged:
        return this.handleSelectionChanged(change);
      case ChangeType.GlobalSelectionChanged:
        return this.handleSelectionChanged(change);
      case ChangeType.ValueChanged:
        return this.handleValueChanged(change);
      default:
        return false;
    }
  }
  /**
   * å¤çè¡åæ¢åæ´
   * @param change åæ´
   * @returns æ¯å¦è·³è¿ç»å®æ°æ®çæ´ä½å·æ°
   */
  private handleSelectionChanged(change: Change): boolean {
    // å½åç»å®è·¯å¾ä¸åçè¡åæ¢äºä»¶ï¼ä¸è¿è¡æ°æ®å·æ°ï¼ä¸ºäºæ¯æTabé®åæ¢ååæ ¼ï¼
    if (change.type === ChangeType.SelectionChanged || change.type === ChangeType.GlobalSelectionChanged) {
      let path = change.path;
      let frmPath = this.bindingData.bindingPath.split("/").filter(str => str);
      if (path.length === frmPath.length) {
        let same = true;
        for (let i = 0; i < path.length; i++) {
          if (path[i] !== frmPath[i])
            same = false;
        }
        if (same)
          return true;
      }
    }
    return false;
  }
  /**
   * å¤çè¡åæ¢åæ´
   * @param change åæ´
   * @returns æ¯å¦è·³è¿ç»å®æ°æ®çæ´ä½å·æ°
   */
  private handleValueChanged(change: Change): boolean {
    if (change.type !== ChangeType.ValueChanged) {
      return false;
    }
    // æ¥æ¶å°å¼ååäºä»¶ï¼å°è¯ä»è¿è¡å±é¨æ°æ®çæ´æ°ï¼ä¸ºäºæ¯æTabé®åæ¢ååæ ¼ï¼
    let path = change.path;
    let bindingPathArr = this.bindingData.bindingPath.split("/").filter(str => str);
    // å¤æ­ç»å®è·¯å¾æ¯å¦ç¸åï¼å¦æä¸ç¸ååæ´ä½å·æ°
    for (let item of bindingPathArr) {
      if (path.length > 0) {
        if (item === path[0]) {
          path.shift();
        } else {
          return false;
        }
      }
    }
    // éè¿idæ¾å°å¾æ´æ°çæ èç¹
    let id = change.id;
    if (id) {
      const primaryKey = this.bindingList.primaryKey;
      let nodes = this.treeTable.value;
      let targetNode = null;
      for (let node of nodes) {
        let result = this.findTreeNodeById(node, primaryKey, id);
        if (result) {
          targetNode = result;
          break;
        }
      }
      if (targetNode && path.length === 1) {
        const propertyName = path.shift();
        if (targetNode.data.hasOwnProperty(propertyName) && change.hasOwnProperty("value")) {
          targetNode.data[propertyName] = change.value;
          return true;
        }
      }
    }
    return false;
  }
  /**
   * éè¿ä¸»é®å¼æ¥æ¾æ èç¹
   * @param treeNode æ æ ¹èç¹
   * @param primaryKey ä¸»é®å
   * @param keyValue ä¸»é®å¼
   * @returns æ èç¹
   * @todo éå½éåå®ç°æ¯è¾ä½æï¼èèéè¿oldTreeNodeMapæ¥æ¾æ èç¹
   */
  private findTreeNodeById(treeNode: TreeNode, primaryKey: string, keyValue: any): TreeNode | null {
    if (!treeNode)
      return null;
    if (treeNode.data.hasOwnProperty(primaryKey) && treeNode.data[primaryKey] === keyValue)
      return treeNode;
    if (treeNode.children) {
      for (let node of treeNode.children) {
        let result = this.findTreeNodeById(node, primaryKey, keyValue);
        if (result)
          return result;
      }
    }
    return null;
  }

  /**
  * ç»å®æ°æ®
  */
  private bindData(change?: Change) {
    let skipRefresh: boolean = this.handleChange(change);
    if (skipRefresh) {
      return;
    }
    // this.sourceData = this.bindingList.toJSON({ ignoreMultiLangInput: true });
    const oldTreeNodes = this.treeTable.value;
    const treeNodesData = this.bindingList.toJSON({ ignoreMultiLangInput: true });
    let treeNodes: TreeNode[] = [];

    if (treeNodesData && treeNodesData.length > 0) {
      let hierarchyInfo = treeNodesData[0][this.hierarchyInfoField];
      const builder: Type<any> = TreeNodeBuilderFactory.getBuilder(hierarchyInfo);
      // æå¡å¨è¿åçåçº§èç¹ä¿¡æ¯å¹éä¸å°ç°æå·¥åéé¢çä»»ä½ä¸ç§æåµãç¡®è®¤æ°å çbuilderå·²ç»å¨å·¥åä¸­æ³¨å
      if (builder == null) {
        throw new Error('TreeTable builder is null!');
      }
      let expandLevel = -1;
      const treeExpandLevel = this.treeTable['expandLevel'];
      if (typeof treeExpandLevel !== 'undefined') {
        expandLevel = treeExpandLevel;
      }
      const context = {
        expandLevel,
        component: this.treeTable,
      };
      const treeNodesBuilder = new builder(
        treeNodesData, oldTreeNodes,
        this.bindingList.primaryKey, this.hierarchyInfoField, context
      );
      treeNodes = treeNodesBuilder.build();
      // è·åç»å®æ°æ®å¯¹åºçå®ä½åè¡¨
      let entityArr: Entity[] = this.getEntityArr();
      // æ ¹æ®treeNodesçé¡ºåºå¨å¯¹åºçå®ä½ä¸æ·»å åºå·å­æ®µ__ACTUAL_INDEX__
      this.setActualIndex(entityArr, treeNodes);
    }

    if (!this.treeTable.lazy) {
      this.treeTable.totalRecords = (this.treeTable._value ? this.treeTable._value.length : 0);
      if (this.treeTable.sortMode == 'single' && this.treeTable.sortField)
        this.treeTable.sortSingle();
      else if (this.treeTable.sortMode == 'multiple' && this.treeTable.multiSortMeta)
        this.treeTable.sortMultiple();
      else if (this.treeTable.hasFilter()) //sort already filters
        this.treeTable._filter();
    }
    this.treeTable.tableService.onUIUpdate(treeNodes);
    this.treeTable.value = treeNodes;
    this.treeTable.updateSerializedValue();

    // this.treeNodeMap = {};
    // this.sourceDataClone = this.sourceData;
    // this.treeTable.value = [...this.treeNodesBuilder()];
    // this.treeTableValueHandler();
  }
  private updateSelectedRow(change: Change) {
    const currentId = this.bindingList.currentId;
    if (this.treeTableSelectedEvent) {
      this.treeTableSelectedEvent = false;
      this.selectedRowId = currentId;
      return;
    }
    const serializedValue = this.treeTable.serializedValue;

    const treeNode = serializedValue && serializedValue.find(item => item && item.node && item.node.data && item.node.data.id === currentId) || null;
    if (treeNode) {
      if (this.treeTable.isSelected(treeNode.node) || currentId === this.selectedRowId) {
        return;
      }
      this.selectedRowId = currentId;
      this.treeTable.handleRowClick({ rowNode: treeNode, originalEvent: { target: { nodeName: '' } } });
    }
  }
  @HostListener('onEditInit', ['$event'])
  public onEditInitHandler(event: any) {
    this.nodeSelectChange.emit(event['data']);
    const id = event.data[this.idField];
    this.setCurrentIdToBindingList(id);
  }


  @HostListener('onEditComplete', ['$event'])
  public onEditCompleteHandler(event: any) {
    let fieldName = event.field;
    const column = this.columns.find(item => item.field === fieldName);
    if (fieldName && column && column.editor && column.editor.options && column.editor.options.type === 'EditorTypes.LOOKUP') {
      return;
    }
    if (event && event.hasOwnProperty('data')) {
      const primaryKeyValue = event.data[this.frameContext.repository.primaryKey];

      let value: any = this.getValue(fieldName, event.data);
      const bindingPath = this.frameContext.viewModel.bindingPath || '/';
      const bindingPaths = bindingPath.split('/').filter(p => p);
      const bindingList: BindingList = this.bindingData.getValue(bindingPaths);
      const bindingObject = bindingList.findById(primaryKeyValue);
      const oldValue = this.getValue(fieldName, bindingObject);
      const column = this.treeTable.columns.find(item => item.field === fieldName);
      const dataType = column && column.dataType || null;
      if (dataType === 'date' || dataType === 'datetime') {
        if (this.dateService) {
          const format = column && column.formatter && column.formatter.options && column.formatter.options.format || 'yyyy-MM-dd';
          value = this.dateService.formatTo(value, format);
          if (!value) {
            value = null;
          }
        }
      } else if (dataType === 'number') {
        value = Number(value);
      }
      if (value !== oldValue) {
        this.updateBindingList(primaryKeyValue, fieldName, value);
      }
    }
  }

  @HostListener('onNodeExpand', ['$event'])
  public onNodeExpandHandler(event: any) {
    // this.setNodeExpandedValue(event);
    const selectedId = event && event.node && event.node.id || null;
    if (!selectedId) {
      return;
    }
    const virtualRootFrameContext = this.frameContext.getVirtualRootFrameContext();
    const expandNodes = virtualRootFrameContext.getParam('TREE_LATEST_EXPANDED_ID') || [];
    expandNodes.push(selectedId);
    virtualRootFrameContext.setParam('TREE_LATEST_EXPANDED_ID', expandNodes);
  }

  @HostListener('onNodeCollapse', ['$event'])
  public onNodeCollapseHandler(event: any) {
    // this.setNodeExpandedValue(event);
  }
  @HostListener('onNodeSelect', ['$event'])
  public onNodeSelectHandler(event: any) {
    const id = event && event.node && event.node.data && event.node.data[this.frameContext.repository.primaryKey] || null;
    if (id === this.bindingList.currentId) {
      return;
    }
    this.treeTableSelectedEvent = true;
    this.setCurrentIdToBindingList(id);
  }
  @HostListener('onNodeUnselect', ['$event'])
  public onNodeUnselectHandler(event: any) {
    this.setCurrentIdToBindingList(null);
  }
  private setNodeExpandedValue(event: any) {
    if (!event || !this.oldTreeNodeMap || Object.keys(this.oldTreeNodeMap).length <= 0) {
      return;
    }
    try {
      let currentId = event.node.data.id;
      this.oldTreeNodeMap[currentId].expanded = event.expanded;
    } catch (e) {
      console.warn(`setNodeExpandedValue error:${e.message}`);
    }
  }
  private setCurrentIdToBindingList(selectedId: string): void {
    const oldCurrentId = this.bindingList.currentId;
    if (oldCurrentId === selectedId) {
      return;
    }
    this.bindingList.setCurrentId(selectedId, true);
  }

  private getPaths(): string[] {
    let paths = [];
    if (!this.frameContext.viewModel || !this.frameContext.viewModel.bindingPath || this.frameContext.viewModel.bindingPath === '/') {
      return paths;
    }
    else {
      let bindingPath = this.frameContext.viewModel.bindingPath;
      paths = bindingPath.substring(1, bindingPath.length).split('/');
      return paths;
    }
  }
  private updateBindingList(primaryValue: any, propertyName: string, value: any) {
    if (!propertyName) {
      return;
    }
    // æ´æ°ä¸»è¡¨é¨åè¡çå­æ®µ
    const propertyNames = propertyName.split('.').filter(item => item);
    const bindingPath = this.getBindingPathArray();
    // ååºæ¥çä¸å®æ¯bindingList
    const list = this.bindingData.getValue(bindingPath) as BindingList;
    // ä¿®æ¹çæ¯å½åè¡
    const paths = bindingPath.concat(propertyNames);
    if (list && primaryValue === list.currentItem.primaryKeyValue) {
      this.bindingData.setValue(paths, value, true, true);
      return;
    }
    const bindingObject = this.bindingList.findById(primaryValue);
    if (!bindingObject) {
      return;
    }
    if (propertyNames.length < 2) {
      bindingObject.setValue(propertyName, value, true, true, undefined, this.bindingData.getValudChangeInvokerFactory()(paths));
    } else {
      let targetBindingObject = null;
      const fpaths = propertyNames.slice(0, propertyNames.length - 1);
      const targetPropertyName = propertyNames[propertyNames.length - 1];
      fpaths.forEach(prop => {
        targetBindingObject = targetBindingObject && targetBindingObject[prop] || bindingObject[prop];
      });
      // todo:éè¦æ·»å å¼ååäºä»¶
      targetBindingObject.setValue(targetPropertyName, value, true, true, undefined, this.bindingData.getValudChangeInvokerFactory()(paths));
    }
  }
  private getBindingPathArray(): any[] {
    const path = this.frameContext.viewModel.bindingPath;
    if (path) {
      return path.split('/').filter(n => n !== '');
    }
    return [];
  }
  private getValue(path: string, data: any) {
    let value = '';
    if (path.indexOf('.') === -1) {
      value = data[path];
    } else {
      value = path.split('.').reduce((result, prop) => {
        return result[prop];
      }, data);
    }
    return value;
  }
  protected setChecks(ids: string[]) {
    this.frameContext.viewModel.uiState.setPropertyValue('ids', ids);
  }
}
